import Gmap2PointLinkCreateUI from './components/Gmap2PointLinkCreateUI/App';

if (document.querySelector('.js-access-gmap-2point-link-create-ui')) {
  new Gmap2PointLinkCreateUI({
    appSelector: '.js-access-gmap-2point-link-create-ui',
    locale: document.querySelector('.js-access-gmap-2point-link-create-ui').dataset.locale,
  });
}

// [START] 外注ソース (chiku-san)
jQuery(function ($) {
  $(function () {
    $('.js-accordion').on('click', function () {
      $(this).children('.js-accordion-arrow').toggleClass('is-active');
      $(this).toggleClass('is-active');
      $(this).next('.js-accordion-panel').slideToggle(300, 'linear');
      $(this).next('.js-accordion-panel').toggleClass('is-active');
    });
  });
});
// [END] 外注ソース (chiku-san)
